module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayThin.0e8b43b.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayThin.eot
// module id = BtWu
// module chunks = 1